import {ActionBuilder} from "co-redux-builders";
import {AlertNotificationRequest} from "../../../model/AlertNotification";

export default ActionBuilder.build({

    onSetCriteria: (newCriteria: AlertNotificationRequest) => ({newCriteria}),
    clearNotificationListCardAdminReducer: () => ({}),
});